<customer-selector [customerID]="customerID" (onChange)="customerSelected($event)"
    [expand]="['Locations', 'SampleBooks', 'PrimaryContact']" style="width:100%;" #customerSelector>
</customer-selector>

<div *ngIf="customer">
    <mat-tab-group>
        <mat-tab label="Account">
            <table class="customer-general-info">
                <tr>
                    <td>Status:</td>
                    <td>{{customer.Status}}</td>
                </tr>
                <tr>
                    <td>Opened:</td>
                    <td>{{customer.DateOpened | date:'mediumDate'}}</td>
                </tr>
                <tr>
                    <td>Age:</td>
                    <td>{{customer.Age}}</td>
                </tr>
                <tr>
                    <td>Class:</td>
                    <td>{{customer.CustomerClass}} - {{customer.CustomerClassDescription}}</td>
                </tr>
                <tr>
                    <td>Price Level:</td>
                    <td>{{customer.PriceLevel}} - {{customer.PriceLevelDesc}}</td>
                </tr>
                <tr>
                    <td>Direct Ship:</td>
                    <td>
                        {{hasDS ? 'Yes' : 'No'}}
                    </td>
                </tr>

                <tr>
                    <td colspan="2">
                        <h3 style="text-decoration: underline; margin-bottom: 0;">Primary Contact</h3>
                    </td>
                </tr>
                <tr *ngIf="customer.PrimaryContact?.DisplayName">
                    <td>Name:</td>
                    <td>{{customer.PrimaryContact?.DisplayName}}</td>
                </tr>
                <tr *ngIf="customer.PrimaryContact?.JobTitle">
                    <td>Title:</td>
                    <td>{{customer.PrimaryContact?.JobTitle}}</td>
                </tr>
                <tr *ngIf="customer.PrimaryContact?.Email">
                    <td>Email:</td>
                    <td><a mat-stroked-button [href]="'mailto:' + customer.PrimaryContact?.Email"
                            target="_blank">{{customer.PrimaryContact?.Email}}</a></td>
                </tr>
                <tr *ngIf="customer.PrimaryContact?.Phone1">
                    <td>{{customer.PrimaryContact?.Phone1Type}}:</td>
                    <td><a mat-stroked-button
                            [href]="'tel:' + customer.PrimaryContact?.Phone1">{{customer.PrimaryContact?.Phone1}}</a>
                    </td>
                </tr>
                <tr *ngIf="customer.PrimaryContact?.Phone2">
                    <td>{{customer.PrimaryContact?.Phone2Type}}:</td>
                    <td><a mat-stroked-button
                            [href]="'tel:' + customer.PrimaryContact?.Phone2">{{customer.PrimaryContact?.Phone2}}</a>
                    </td>
                </tr>

                <tr>
                    <td colspan="2">
                        <h3 style="text-decoration: underline; margin-bottom: 0;">Location</h3>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <mat-form-field *ngIf="customer" appearance="fill">
                            <mat-label>Customer Location</mat-label>
                            <mat-select [(ngModel)]="customerLocation" name="customerLocation">
                                <mat-option *ngFor="let loc of customer.Locations" [value]="loc">
                                    <div class="customerLocation">
                                        {{loc.LocationID}} - {{loc.LocationName}}<br />
                                        {{loc.AddressLine1}}<br />
                                        {{loc.City}}, {{loc.State}} {{loc.PostalCode}}
                                    </div>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td>Address:</td>
                    <td>
                        <a mat-stroked-button target="_blank"
                            [href]="'http://maps.google.com/?q=' + displayLocationMapQuery">
                            {{displayLocation?.AddressLine1}}<br />
                            <span *ngIf="displayLocation?.AddressLine2">{{displayLocation?.AddressLine2}}<br /></span>
                            {{displayLocation?.City}}, {{displayLocation?.State}} {{displayLocation?.PostalCode}}
                        </a>
                    </td>
                </tr>
                <tr *ngIf="customer.Phone1">
                    <td>{{customer.Phone1Type}}:</td>
                    <td><a mat-stroked-button [href]="'tel:' + customer.Phone1">{{customer.Phone1}}</a></td>
                </tr>
                <tr *ngIf="customer.Phone2">
                    <td>{{customer.Phone2Type}}: <a mat-stroked-button
                            [href]="'tel:' + customer.Phone1">{{customer.Phone2}}</a>
                    </td>
                </tr>
                <tr *ngIf="customer.Fax">
                    <td>{{customer.FaxType}}:</td>
                    <td><a mat-stroked-button [href]="'tel:' + customer.Phone1">{{customer.Fax}}</a></td>
                </tr>
                <tr *ngIf="customer.Email">
                    <td>Email:</td>
                    <td><a mat-stroked-button [href]="'mailto:' + customer.Email" target="_blank">{{customer.Email}}</a>
                    </td>
                </tr>
                <tr *ngIf="customer.Web">
                    <td>Web:</td>
                    <td><a mat-stroked-button [href]="'https://' + customer.Web" target="_blank">{{customer.Web}}</a>
                    </td>
                </tr>
            </table>
        </mat-tab>

        <mat-tab label="Sales">
            <table>
                <tr>
                    <td>
                        <mat-form-field appearance="fill" *ngIf="customer" style="width:60vw">
                            <mat-label>Sales Status</mat-label>
                            <mat-select [(value)]="customer.SalesStatus" (selectionChange)="updateSalesStatus($event)">
                                <mat-option *ngFor="let status of CustomerSalesStatusList" [value]="status.internal">{{status.external}}</mat-option>
                            </mat-select>
                        </mat-form-field>                    
                    </td>

                    <td>
                        <mat-form-field appearance="fill" style="width:30vw">
                            <mat-label>Next Appt</mat-label>
                            <input matInput [matDatepicker]="picker" [(ngModel)]="customer.NextAppt" (dateChange)="updateNextApptDate($event)" />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <mat-form-field appearance="fill" style="width:95vw;">
                            <mat-label>Rep Note</mat-label>
                            <textarea matInput [(ngModel)]="customer.RepNotes"
                                style="height: 4em; max-width:500px;" (blur)="updateRepNotes($event)"></textarea>
                        </mat-form-field>
                    </td>
                </tr>
            </table>
        </mat-tab>

        <mat-tab label="Sample Books">
            <mat-accordion class="sample-books left-align">
                <mat-expansion-panel *ngFor="let book of customer.SampleBooks" #bookPanel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{book.InventoryID}}</mat-panel-title>
                        <mat-panel-description>{{book.Description}}</mat-panel-description>
                    </mat-expansion-panel-header>

                    <mat-form-field apperance="fill" style="width:90%;">
                        <mat-label>Book Notes</mat-label>
                        <input matInput [(ngModel)]="book.Notes" maxlength="1000" (focus)="focusBookNotes(book)"
                            (blur)="updateBookNotes(book)" />
                    </mat-form-field>
                    <button matSuffix mat-icon-button [matMenuTriggerFor]="menu" style="float:right;">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="removeBook(book, bookPanel)">Remove Book</button>
                    </mat-menu>

                    <div>Last Checked: {{book.LastChecked | date}}</div>
                </mat-expansion-panel>
            </mat-accordion>

        </mat-tab>

        <mat-tab *ngIf="customer?.PriceListAuthToken" label="Price Lists">
            <div>Price Level: {{customer.PriceLevel}} - {{customer.PriceLevelDesc}}</div>
            <div *ngIf="pricing.Effective" style="font-size:150%; text-align:center;">Current Pricing</div>
            <table class="price-lists">
            <thead>
                <tr>
                    <td>PRICE LIST</td>
                    <td colspan="2">CUSTOMER PRICING</td>
                    <td colspan="2">RETAIL PRICING</td>
                </tr>
            </thead>
            <tbody>
            <tr *ngFor="let list of priceLists">
                <td>{{list.label}}</td>
                <ng-container *ngFor="let pricing of ['customer', 'retail']">
                <ng-container *ngFor="let format of ['pdf', 'xls']">
                    <td><a mat-icon-button target="_blank" href="https://images.mayerfabrics.com/price-list/{{customer.CustomerID}}?format={{format}}&pricing={{pricing}}&type={{list.type}}&auth={{customer.PriceListAuthToken}}">
                        <mat-icon>{{format=='pdf' ? 'picture_as_pdf' : 'table_chart'}}</mat-icon>
                    </a></td>
                </ng-container>
                </ng-container>
            </tr>
            </tbody>
            </table>

            
            <div *ngIf="pricing.Effective && pricing.Effective > today">
                <hr />
                <div style="font-size:150%; text-align:center;">Upcoming Price Changes</div>
                <div *ngIf="pricing.Available! > today">Available to Customers: {{pricing.Available!.format("dddd, MMM dS, yyyy")}}</div>
                <div>Effective: {{pricing.Effective!.format("dddd, MMM dS, yyyy")}}</div>
                <table class="price-lists" style="margin-top:1em;">
                <thead>
                    <tr>
                        <td>PRICE LIST</td>
                        <td colspan="2">CUSTOMER PRICING</td>
                        <td colspan="2">RETAIL PRICING</td>
                    </tr>
                </thead>
                <tbody>
                <tr *ngFor="let list of priceLists">
                    <td>{{list.label}}</td>
                    <ng-container *ngFor="let priceType of ['customer', 'retail']">
                    <ng-container *ngFor="let format of ['pdf', 'xls']">
                        <td><a mat-icon-button target="_blank" href="https://images.mayerfabrics.com/price-list/{{customer.CustomerID}}?format={{format}}&pricing={{priceType}}&type={{list.type}}&auth={{customer.PriceListAuthToken}}{{pricing.AsOfParam}}">
                            <mat-icon>{{format=='pdf' ? 'picture_as_pdf' : 'table_chart'}}</mat-icon>
                        </a></td>
                    </ng-container>
                    </ng-container>
                </tr>
                </tbody>
                </table>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>